import firebase from '@/firebase'
import { FS_COLLECTIONS } from '@/firebase'
const db = firebase.firestore()
var cargadorCatalogosDescuentos = null;

const store = {
  state: {
    listaDescuentos: {},
  },
  getters: {
    listaDescuentos: state => {
      return state.listaDescuentos
    },
  },
  mutations: {
    ASIGNA_CATALOGO_DESCUENTOS(state, listaDescuentos) {
      state.listaDescuentos = listaDescuentos
    },
  },
  actions: {
    restablecerValoresDescuentos({commit}){
      commit('ASIGNA_SERVICIOS_POR_CATEGORIA',{})
      commit('ASIGNA_SERVICIOS_POR_SUBCATEGORIA',{})
      commit('ASIGNA_SERVICIOS_POR_PRINCIPALES',{})
      commit('ASIGNA_SERVICIOS_POR_PRINCIPALES_GENERAL',{})
      commit('ASIGNA_PRODUCTOS_POR_CATEGORIA',{})
      commit('ASIGNA_PRODUCTOS_POR_SUBCATEGORIA',{})
      commit('ASIGNA_PRODUCTOS_POR_LINEA',{})
      commit('ASIGNA_PRODUCTOS_POR_PRINCIPALES',{})
    },
    guardarDescuento({ getters }, descuento) {
        return new Promise((resolve, reject) => {
            db.collection(FS_COLLECTIONS.FRANQUICIAS)
            .doc(getters.franquicia.id).collection(FS_COLLECTIONS.DESCUENTOS)
              .add(descuento)
              .then(docRefServicio => {
                resolve(docRefServicio)
            })
            .catch(error => {
                reject(error)
            })
        })
    },
    cargaDescuentos({ commit, getters }) {
      return new Promise((resolve, reject) => {
        let docPath = db
              .collection(FS_COLLECTIONS.FRANQUICIAS)
              .doc(getters.franquicia.id)
              .collection(FS_COLLECTIONS.INDICES)
              .doc(FS_COLLECTIONS.DESCUENTOS)
            cargadorCatalogosDescuentos = docPath.onSnapshot(doc => {
              //console.log('Current data espacios: ', doc.data())
              commit('ASIGNA_CATALOGO_DESCUENTOS', doc.data());
              resolve(doc.data());
            })
      })
    },
    cargaDescuentoActual({getters,commit}, id){
      return new Promise((resolve) => {
        let docPath = db
          .collection(FS_COLLECTIONS.FRANQUICIAS)
          .doc(getters.franquicia.id)
          .collection(FS_COLLECTIONS.DESCUENTOS)
          .doc(id)
          docPath.get().then(doc => {
            console.log("DESCUENTO DESDE STORE")
            console.log(doc.data())
            resolve(doc.data())
          });
      });
    },
    eliminaDescuento({getters},id){
      return new Promise((resolve) => {
      let docPath = db
          .collection(FS_COLLECTIONS.FRANQUICIAS)
          .doc(getters.franquicia.id)
          .collection(FS_COLLECTIONS.DESCUENTOS)
          .doc(id)
          docPath.get().then(doc => {
            console.log("DESCUENTO Objenido para eliminar")
            let descuento = doc.data()
            descuento.info.activo = false;
            
                db.collection(FS_COLLECTIONS.FRANQUICIAS)
                .doc(getters.franquicia.id)
                .collection(FS_COLLECTIONS.DESCUENTOS)
                .doc(id).update(descuento).then(() => {
                  resolve();
                }).catch(error => {
                  reject(error);
                })
            }).catch(error => {
              reject(error);
            })
      });
    }
  }
}

export default store



// WEBPACK FOOTER //
// ./src/store/descuentos/descuentos.js